import { useState } from "react";
import { useTheme } from "next-themes";
import BrandMark from "@/components/brand/BrandMark";
import { navLinks } from "./navLinks";

const SunIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
  </svg>
);

const MoonIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />
  </svg>
);

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const themeLabel = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-[var(--nav-bg)] backdrop-blur-[14px] backdrop-saturate-[1.4]">
      <div className="mx-auto flex h-[68px] max-w-[1200px] items-center gap-5 px-[clamp(16px,5vw,48px)]">
        <a href="#top" className="text-foreground hover:text-foreground" onClick={() => setMenuOpen(false)}>
          <BrandMark />
        </a>

        <nav className="ml-5 hidden gap-1 min-[900px]:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-lg px-3.5 py-2 text-[15px] font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <button
            type="button"
            onClick={() => setTheme(isDark ? "light" : "dark")}
            aria-label={themeLabel}
            title={themeLabel}
            className="grid h-10 w-10 place-items-center rounded-[10px] border border-border bg-transparent text-foreground hover:bg-secondary"
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
          </button>
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="hidden h-10 items-center whitespace-nowrap rounded-[10px] bg-btn min-[480px]:inline-flex px-[18px] text-[15px] font-semibold text-[color:var(--btn-fg)] shadow-primary transition-transform hover:-translate-y-px hover:text-[color:var(--btn-fg)]"
          >
            Get in touch
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="Menu"
            aria-expanded={menuOpen}
            className="flex h-10 w-10 flex-col items-center justify-center gap-[5px] rounded-[10px] border border-border bg-transparent min-[900px]:hidden"
          >
            <span className="h-[1.5px] w-4 bg-foreground" />
            <span className="h-[1.5px] w-4 bg-foreground" />
            <span className="h-[1.5px] w-4 bg-foreground" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="flex flex-col border-t border-border bg-background px-[clamp(16px,5vw,48px)] pb-4 pt-2 min-[900px]:hidden">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="flex min-h-[52px] items-center justify-between border-b border-border text-lg font-medium text-foreground hover:text-foreground"
            >
              {link.label}
              <span className="font-mono text-sm text-muted-foreground" aria-hidden="true">→</span>
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="mt-4 flex min-h-[50px] items-center justify-center rounded-xl bg-btn text-base font-semibold text-[color:var(--btn-fg)] hover:text-[color:var(--btn-fg)]"
          >
            Get in touch
          </a>
        </nav>
      )}
    </header>
  );
};

export default Navigation;
